<template>
  <div class="header-container">
    <header class="header">
      <div class="header-inner">
        <div
          class="brand"
          @click="navigateTo('LandingPage')"
          @keydown.enter.prevent="navigateTo('LandingPage')"
          @keydown.space.prevent="navigateTo('LandingPage')"
          role="button"
          tabindex="0"
        >
          <img src="@/assets/logo_small.png" alt="OCN Gübre" class="logo" />
          <span class="brand-name">OCN Gübre</span>
        </div>

        <nav class="nav">
          <a
            v-for="link in links"
            :key="link.name"
            :class="{ active: isActive(link.name) }"
            @click.prevent="navigateTo(link.name)"
          >
            {{ link.label }}
          </a>
        </nav>

        <button class="contact-btn" @click="navigateTo('AppIletisim')">
          İLETİŞİM
        </button>
      </div>
    </header>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';

export default {
  name: 'AppHeader',
  setup() {
    const router = useRouter();
    const route = useRoute();

    const links = [
      { label: 'Kurumsal', name: 'AppKurumsal' },
      { label: 'Ürünler', name: 'AppUrunler' },
      { label: 'Tohumlar', name: 'AppTohumlar' },
      { label: 'KARİYER', name: 'AppKariyer' }
    ];

    const navigateTo = (routeName) => {
      router.push({ name: routeName });
    };

    const isActive = (routeName) => route.name === routeName;

    return { links, navigateTo, isActive };
  }
};
</script>

<style scoped>
.header-container {
  position: sticky;
  top: 0;
  z-index: 20;
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(255, 255, 255, 0.75) 100%);
  backdrop-filter: blur(6px);
}

.header {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}

.header-inner {
  box-sizing: border-box;
  width: var(--page-width);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #e8edf2;
  border-radius: 16px;
  padding: 14px 18px;
  box-shadow: 0 18px 48px rgba(0, 21, 58, 0.08);
  backdrop-filter: blur(10px);
}

.logo {
  height: 38px;
  cursor: pointer;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #0f172a;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 12px;
}

.brand-name {
  white-space: nowrap;
}

.nav {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  justify-content: center;
}

.nav a {
  text-decoration: none;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid transparent;
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.nav a:hover {
  cursor: pointer;
  color: #0f766e;
  background-color: #eff8f6;
  border-color: #c9e7df;
}

.nav a.active {
  color: #0f766e;
  background-color: #e8f5f1;
  border-color: #b7dfd4;
  box-shadow: 0 8px 20px rgba(15, 118, 110, 0.14);
}

.contact-btn {
  background: #0f172a;
  color: #f8fafc;
  border: 1px solid #0f172a;
  border-radius: 12px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.contact-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.18);
  background: #111827;
}

@media (max-width: 1080px) {
  .header-inner {
    gap: 16px;
  }

  .nav {
    gap: 4px;
  }
}

@media (max-width: 920px) {
  .header-inner {
    padding: 12px 14px;
  }

  .brand-name {
    display: none;
  }
}
</style>
